import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getGrammarLessonV1DataSchema } from '../getGrammarLessonV1';
import { grammarPointAudioSchema } from '../schemas';

const getGrammarLessonV2DataSchemaDefinition = getGrammarLessonV1DataSchema.extend({
  serveToken: z.string(),
  audio: grammarPointAudioSchema.optional(),
});

export const getGrammarLessonV2DataSchema: typeof getGrammarLessonV2DataSchemaDefinition =
  getGrammarLessonV2DataSchemaDefinition;

export type IGetGrammarLessonV2Data = z.infer<typeof getGrammarLessonV2DataSchema>;

export const getGrammarLessonV2ResponseSchema: z.ZodSchema<IAPI<IGetGrammarLessonV2Data>> =
  createApiResponseSchema(getGrammarLessonV2DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarLessonV2Data>
  >;

export type IGetGrammarLessonV2Response = IAPI<IGetGrammarLessonV2Data>;
